// Control the height of each image on mobile
function adjustFigureHeight() {
    const heroSections = document.querySelectorAll('.hero-full-bleed');

    heroSections.forEach(hero => {
        const columnContent = hero.querySelector('.column-content:has(form)');
        const figure = hero.querySelector('figure');

        if (window.innerWidth <= 991) {
            if (columnContent && figure) {
                const contentHeight = columnContent.offsetHeight;
                figure.style.maxHeight = `calc(100% - ${contentHeight}px)`;
            }
        } else {
            if (figure) figure.style.maxHeight = '';
        }
    });
}

window.addEventListener('resize', adjustFigureHeight);
window.addEventListener('load', adjustFigureHeight);